import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import {
  formatRP,
  getDateToday,
  pembilang,
} from "../../../../Utils/externalFunctions";

const styles = StyleSheet.create({
  body: { color: "black", margin: 30, fontSize: 8 },
  column: {
    flexDirection: "column",
  },
  row: {
    flexDirection: "row",
  },
  table: {
    display: "table",
    marginTop: 15,
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableBorderBottom: {
    display: "table",
    marginTop: 10,
    paddingBottom: 10,
    width: "auto",
    borderStyle: "solid",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColNoBorder: {
    borderStyle: "solid",
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
  },
});

const MyDocument = ({
  formUMK,
  anggaranUMK,
  unitKerjaList,
  anggaranDipakaiUMK,
}) => {
  const getPimpimpinan = () => {
    const pimpinan = unitKerjaList.find(
      (unit) => unit.nama_unit_kerja === formUMK.id_unit_kerja
    );
    return pimpinan?.nama_kepala || "loading";
  };

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.column}>
        <View style={styles.body}>
          <View style={{ width: "auto" }}>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "80%" }]}>
                <Text style={{ marginTop: 2 }}></Text>
              </View>
              <View style={[styles.row, { width: "4%" }]}>
                <Text style={{ marginTop: 2 }}>Nomor</Text>
              </View>
              <View style={[styles.row, { width: "1%" }]}>
                <Text style={{ marginTop: 2 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 2 }}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "80%" }]}>
                <Text style={{ marginTop: 2 }}></Text>
              </View>
              <View style={[styles.row, { width: "4%" }]}>
                <Text style={{ marginTop: 2 }}>Tanggal</Text>
              </View>
              <View style={[styles.row, { width: "1%" }]}>
                <Text style={{ marginTop: 2 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 2 }}>{getDateToday()}</Text>
              </View>
            </View>
          </View>
          <Text
            style={{
              textAlign: "center",
              fontSize: 14,
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            Formulir Pengajuan Anggaran (FPA)
          </Text>
          <View style={{ width: "auto" }}>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Nama SA</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>11101_FASILKOM</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Terbilang (Bruto)</Text>
              </View>
              <View style={[styles.row, { width: "4.6%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30.4%" }]}>
                <Text style={{ marginTop: 5 }}>{pembilang(formUMK.nilai)}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Nama DPSJ</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>{formUMK.id_unit_kerja}</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Jumlah Dibayar (Bruto)</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>
                  Rp.
                  {formUMK && formUMK.nilai
                    ? formUMK.nilai
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : formUMK.nilai}
                </Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Jenis Pengeluaran</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>UMK</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Untuk Pembayaran</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>{formUMK.keterangan}</Text>
              </View>
            </View>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "5%" }]}>
                <Text style={styles.tableCell}>NO</Text>
              </View>
              <View style={[styles.tableCol, { width: "30%" }]}>
                <Text style={styles.tableCell}>NAMA KEGIATAN</Text>
              </View>
              <View style={[styles.tableCol, { width: "30%" }]}>
                <Text style={styles.tableCell}>Akun</Text>
              </View>
              <View style={[styles.tableCol, { width: "5%%" }]}>
                <Text style={styles.tableCell}>DANA</Text>
              </View>
              <View style={[styles.tableCol, { width: "10%" }]}>
                <Text style={styles.tableCell}>Sisa Sebelumnya</Text>
              </View>
              <View style={[styles.tableCol, { width: "10%" }]}>
                <Text style={styles.tableCell}>JUMLAH BRUTO</Text>
              </View>
              <View style={[styles.tableCol, { width: "10%" }]}>
                <Text style={styles.tableCell}>SISA ANGGARAN</Text>
              </View>
            </View>
          </View>
          {anggaranUMK.map((umk, index) => (
            <View style={styles.tableBorderBottom} key={umk.pk}>
              <View style={styles.tableRow}>
                <View style={[styles.borderWidth, { width: "5%" }]}>
                  <Text style={styles.tableCell}>{index + 1}</Text>
                </View>
                <View style={[styles.borderWidth, { width: "30%" }]}>
                  <Text style={styles.tableCell}>
                    {umk.kd_keg + " - " + umk.nm_keg}
                  </Text>
                </View>
                <View style={[styles.borderWidth, { width: "30%" }]}>
                  <Text style={styles.tableCell}>
                    {umk.kd_akun + " - " + umk.nm_akun}
                  </Text>
                </View>
                <View style={[styles.borderWidth, { width: "5%%" }]}>
                  <Text style={styles.tableCell}>{umk.id_sumber_dana}</Text>
                </View>
                <View style={[styles.borderWidth, { width: "10%" }]}>
                  <Text style={styles.tableCell}>
                    Rp.
                    {formatRP(
                      parseFloat(
                        anggaranDipakaiUMK.find((item) => {
                          return item.rencana_imp === umk.pk;
                        })?.anggaran_digunakan
                      ) + parseFloat(umk.anggaran_tersisa)
                    )}
                  </Text>
                </View>
                <View style={[styles.borderWidth, { width: "10%" }]}>
                  <Text style={styles.tableCell}>
                    Rp.
                    {anggaranDipakaiUMK
                      .find((item) => {
                        return item.rencana_imp === umk.pk;
                      })
                      ?.anggaran_digunakan.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </Text>
                </View>
                <View style={[styles.borderWidth, { width: "10%" }]}>
                  <Text style={styles.tableCell}>
                    Rp.
                    {umk.anggaran_tersisa
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </Text>
                </View>
              </View>
            </View>
          ))}

          <View style={{ marginTop: 15 }}>
            <Text>
              *) Formulir Pengajuan Anggaran (FPA) harus dicap tanda tangan
              basah.
            </Text>
          </View>
          <View style={{ marginTop: 3 }}>
            <Text>
              *) Dana: 51 - (Dana Masyarakat (BP) - Tidak Terikat), 61 - (Dana
              Masyarakat (Non BP) - Tidak Terikat), 81 - (Dana Khusus).
            </Text>
          </View>
          <View style={styles.tablenoborder}>
            <View style={[styles.tableRow, { marginTop: 30 }]}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text>Disetujui Oleh,</Text>
              </View>
              <View style={[styles.borderWidth, { width: "25%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>Disetujui Oleh</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "20%" }]}>
                <Text>Pimpinan Unit Pemohon,</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "6%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "4%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>
                  {parseInt(formUMK.nilai) < 25000000
                    ? "Manajer Keuangan,"
                    : "Wakil Dekan"}
                </Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
            <View style={[styles.tableRow, { marginTop: 50 }]}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "20%" }]}>
                <Text>({getPimpimpinan()})</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>
                  {parseInt(formUMK.nilai) < 25000000
                    ? "(Edina Ayuningtyas)"
                    : "(Achmad Nizar Hidayanto)"}
                </Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument;
